import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=04c2c7e2&scoped=true&"
import script from "./accountList.vue?vue&type=script&lang=js&"
export * from "./accountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c2c7e2",
  null
  
)

export default component.exports